import React, {Component} from 'react';
import Navigation from './Navigation';
import { NavLink } from 'react-router-dom';

const logoImage = require('../../graphics/logo-temp.png');

// Since this component is simple and static, there's no parent container for it.
class NavigationBar extends Component {
  render(){
    return (
      <div className="navi">
        <NavLink exact to="/">
          <div id="logo"><img src={logoImage} alt=""/></div>
        </NavLink>
        <Navigation/>
      </div>
    )
  }
}

export default NavigationBar;


// WEBPACK FOOTER //
// ./src/components/common/NavigationBar.js